import { render } from "./register-stepper-header.vue?vue&type=template&id=a44b6d46&scoped=true&ts=true"
import script from "./register-stepper-header.vue?vue&type=script&lang=ts"
export * from "./register-stepper-header.vue?vue&type=script&lang=ts"

import "./register-stepper-header.vue?vue&type=style&index=0&id=a44b6d46&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44b6d46"]])

export default __exports__